export function normalizeMalformedAegisUrl(rawUrl) {
  const value = String(rawUrl || "").trim();
  if (!value) return "";

  const normalizeFlat = (input) => {
    let next = String(input || "").trim();
    if (!next) return next;
    next = next
      .replace(/https:\/\/aegis\.ai-vai\.com\/https:\/\/aegis\.ai-vai\.com\//gi, "https://aegis.ai-vai.com/")
      .replace(/http:\/\/aegis\.ai-vai\.com\/http:\/\/aegis\.ai-vai\.com\//gi, "http://aegis.ai-vai.com/")
      .replace(/https%3A%2F%2Faegis\.ai-vai\.com%2Fhttps%3A%2F%2Faegis\.ai-vai\.com%2F/gi, "https%3A%2F%2Faegis.ai-vai.com%2F")
      .replace(/http%3A%2F%2Faegis\.ai-vai\.com%2Fhttp%3A%2F%2Faegis\.ai-vai\.com%2F/gi, "http%3A%2F%2Faegis.ai-vai.com%2F");

    try {
      const url = new URL(next, typeof window !== "undefined" ? window.location.origin : "https://burosoul.ru");
      const path = url.pathname || "";
      if ((path.startsWith("/https://") || path.startsWith("/http://"))) {
        const nested = new URL(path.slice(1));
        if (nested.host && nested.host.toLowerCase() === url.host.toLowerCase()) {
          nested.search = nested.search || url.search || "";
          nested.hash = nested.hash || url.hash || "";
          next = nested.toString();
        }
      }
    } catch {
      // keep best-effort value
    }

    return next;
  };

  let normalized = normalizeFlat(value);

  try {
    const url = new URL(normalized, typeof window !== "undefined" ? window.location.origin : "https://burosoul.ru");
    let changed = false;
    const entries = Array.from(url.searchParams.entries());
    entries.forEach(([key, paramValue]) => {
      let nextValue = normalizeFlat(paramValue);
      try {
        const decoded = decodeURIComponent(paramValue);
        const decodedNormalized = normalizeFlat(decoded);
        if (decodedNormalized !== decoded) nextValue = decodedNormalized;
      } catch {
        // keep nextValue
      }
      if (nextValue !== paramValue) {
        url.searchParams.set(key, nextValue);
        changed = true;
      }
    });
    if (changed) normalized = url.toString();
  } catch {
    // keep best-effort normalized value
  }

  return normalized;
}
